'use strict';

import { getJSON } from '../util';
import { queryFirst, addClass, removeClass } from '../domUtil';
const { HIDDEN_CLASS } = require('../constants');

const invalidClass = 'is-invalid';
const checkBalanceForm = queryFirst('.gift-card-balance-check-form');
const balanceInfoEl = queryFirst('.balance-info', checkBalanceForm);
const errorMessageNode = queryFirst('.gift-error-message', checkBalanceForm);
const checkBalanceBtn = queryFirst('.check-balance', checkBalanceForm);
const maxGcReachedCheckBalanceBtn = queryFirst('.max-gift-cards-reached-button', checkBalanceForm);
const applyBtn = queryFirst('.apply-balance', checkBalanceForm);

let cardNumberInput;
let cardPinInput;

/**
 * Function to handle Gift card success senario
 * @param {string} response - Gift card response with success message and balance value
 */
function handleSuccess(response) {
    const { successMessage, balance } = response.giftCertificate;
    errorMessageNode.innerHTML = '';
    if (successMessage) {
        balanceInfoEl.innerHTML = `${successMessage} <span class="value">${balance}</span>`;
        removeClass(balanceInfoEl, HIDDEN_CLASS);
    } else {
        addClass(balanceInfoEl, HIDDEN_CLASS);
    }
}

/**
 * Function to handle Gift card error senario
 * @param {string} errorResponse - Gift card error senario param
 */
function handleError(errorResponse) {
    balanceInfoEl.innerHTML = '';
    if (errorResponse.error) {
        errorMessageNode.innerHTML = `<span class="error">${errorResponse.error}</span>`;
    }
}

/**
 * Function to validate gift card
 * @param {string} cardNumber - Gift card number
 * @param {string} cardPin - Gift card PIN
 */
function validateGiftCard(cardNumber, cardPin) {
    const { actionUrl } = checkBalanceForm.dataset;
    const csrfTokenInput = queryFirst('.csrf-token', checkBalanceForm);
    const spinner = $(checkBalanceForm).spinner();
    let csrfToken;

    if (csrfTokenInput) {
        csrfToken = csrfTokenInput.value;
    }

    const checkoutPage = document.getElementById('checkout-main');

    spinner.start();

    if (actionUrl) {
        getJSON(
            actionUrl,
            'POST',
            {
                csrf_token: csrfToken,
                gcId: cardNumber,
                gcPin: cardPin,
                shortResponseMessage: !!checkoutPage
            },
            response => {
                if (response.error) {
                    handleError(response);
                } else {
                    handleSuccess(response);
                }
                spinner.stop();
            },
            error => {
                handleError(error);
                spinner.stop();
            }
        );
    }
}

/**
 * Function to handle form submit action
 *
 * @param {string} event - Event object
 */
function handleCheckBalanceClick(event) {
    event.preventDefault();
    validateGiftCard(cardNumberInput.value, cardPinInput.value);
    if (!applyBtn) return;
    if (applyBtn.getAttribute('disabled') === 'true') {
        removeClass(maxGcReachedCheckBalanceBtn, HIDDEN_CLASS);
        addClass(applyBtn, HIDDEN_CLASS);
    }
    addClass(checkBalanceBtn, HIDDEN_CLASS);
}

/**
 * Function to clear error state
 *
 * @param {string} event - Event object
 */
function clearErrorState(event) {
    removeClass(event.target, invalidClass);

    if (errorMessageNode) {
        errorMessageNode.innerHTML = '';
    }
}

/**
 * On Input Event handler for Gift card Pin field
 * @param {string} event - Event object
 */
function onInputHandler(event) {
    clearErrorState(event);

    const inputEl = event.target;
    const currentLength = inputEl.value.length;
    const maxLength = parseInt(inputEl.getAttribute('maxlength'), 10);

    if (maxLength && currentLength > maxLength) {
        inputEl.value = inputEl.value.substring(0, maxLength);
    }
}

/**
 * Keydown event handler
 * @param {string} event - Event object
 * @returns {boolean} - returns event is cancelled or not
 */
function avoidExponentCharacter(event) {
    if (event.keyCode === 69) {
        event.preventDefault();
        return false;
    }
    if (event.keyCode === 13) {
        event.preventDefault();
        applyBtn.click();
        return false;
    }
    return true;
}

/**
 * Checks if both input fields have values.
 * If both inputs are not empty, the button is displayed.
 */
function checkInputs() {
    if (!applyBtn) return;
    const isMaxGcApplied = queryFirst('.max-gift-cards-reached-button.d-none');
    if (applyBtn.disabled) return false;
    if (cardNumberInput.value.trim() !== '' && cardPinInput.value.length === 4 && !!isMaxGcApplied) {
        removeClass(checkBalanceBtn, HIDDEN_CLASS);
    } else {
        addClass([checkBalanceBtn, balanceInfoEl], HIDDEN_CLASS);
    }
}

/**
 * Function to initialize events
 */
function initEvents() {
    cardNumberInput.addEventListener('keydown', avoidExponentCharacter);
    cardNumberInput.addEventListener('input', (e) => {
        onInputHandler(e);
        checkInputs(e);
    });

    cardPinInput.addEventListener('keydown', avoidExponentCharacter);
    cardPinInput.addEventListener('input', (e) => {
        onInputHandler(e);
        checkInputs(e);
    });

    checkBalanceBtn.addEventListener('click', _event => handleCheckBalanceClick(_event));
    maxGcReachedCheckBalanceBtn?.addEventListener('click', _event => handleCheckBalanceClick(_event));
}

if (checkBalanceForm) {
    cardNumberInput = queryFirst('.gift-card-number .form-control', checkBalanceForm);
    cardPinInput = queryFirst('.gift-card-pin .form-control', checkBalanceForm);

    if (cardNumberInput && cardPinInput) {
        initEvents();
    }
}

export default {
    initEvents: initEvents
};
